import React from 'react';
import * as PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import './Example.css';
import {
  Breadcrumb, Icon, Row, Form,
} from 'antd';
import PanelLayout from '../../../../components/panels/PanelLayout';
import routeLocations from '../../../../utility/route-locations';


function ExamplePage() {
  return (
    <section className="developer-page">
      <Row type="flex" justify="space-between" align="middle">
        <Breadcrumb separator=">" itemRender="">
          <Breadcrumb.Item>
            <Link className="app-standard-link" to={routeLocations.dashboard}><Icon type="home" /></Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link className="app-standard-link" to={routeLocations.developer}><FormattedMessage id="developer.short" /></Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item><FormattedMessage id="example.short" /></Breadcrumb.Item>
        </Breadcrumb>
      </Row>
      <PanelLayout titleId="example" titleLevel={2}>
        <Row type="flex" justify="end">
          <Link className="app-standard-link" to={routeLocations.developer_layouts} style={{ marginTop: '-3em' }}>
            <FormattedMessage id="goto" />
            &nbsp;
            <FormattedMessage id="layouts.short" />
          </Link>
        </Row>
      </PanelLayout>
    </section>
  );
}

// Validate the prop type parameters.
ExamplePage.propTypes = {
  form: PropTypes.shape({
    validateFields: PropTypes.func.isRequired,
    getFieldDecorator: PropTypes.func.isRequired,
  }).isRequired,
};

// Let antd automatically collect and validate data.
const Example = injectIntl(Form.create({})(ExamplePage));

export default Example;
